import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Soma350mgRx() {
  const navigate = useNavigate();
  const [selectedPackage, setSelectedPackage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const product = {
    id: 106,
    name: 'Soma 350mg',
    category: 'Pain Relief',
    images: [
      'https://public.readdy.ai/ai/img_res/c4cb0d43d8d822f06dec9294b4697995.jpg'
    ],
    rating: 4.7,
    reviewCount: 328,
    inStock: true,
    description: 'Soma (Carisoprodol) 350mg is a muscle relaxer that blocks pain sensations between the nerves and the brain. It is used together with rest and physical therapy to treat skeletal muscle conditions such as pain or injury.',
    prescriptionRequired: true
  };

  const packages = [
    { pills: 100, price: 200 },
    { pills: 170, price: 300 },
    { pills: 250, price: 400 },
    { pills: 300, price: 500 },
    { pills: 350, price: 600 },
    { pills: 500, price: 800 }
  ];

  const handleAddToCart = () => {
    const cartItem = {
      ...product,
      selectedPackage: packages[selectedPackage],
      quantity,
      totalPrice: packages[selectedPackage].price * quantity
    };
    
    const existingCart = JSON.parse(localStorage.getItem('cart') || '[]');
    const existingItemIndex = existingCart.findIndex(
      (item: any) => item.id === product.id && item.selectedPackage.pills === packages[selectedPackage].pills
    );

    if (existingItemIndex > -1) {
      existingCart[existingItemIndex].quantity += quantity;
      existingCart[existingItemIndex].totalPrice = existingCart[existingItemIndex].quantity * packages[selectedPackage].price;
    } else {
      existingCart.push(cartItem);
    }

    localStorage.setItem('cart', JSON.stringify(existingCart));
    navigate('/cart');
  };

  return (
    <div className="min-h-screen bg-white pb-20">
      {/* Header */}
      <div className="fixed top-0 left-0 right-0 bg-white z-50 px-4 py-3 flex items-center shadow-sm">
        <button onClick={() => navigate(-1)} className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-left-line text-xl"></i>
        </button>
        <h1 className="flex-1 text-center font-semibold text-lg pr-8">Product Details</h1>
      </div>

      {/* Content */}
      <div className="pt-14">
        {/* Product Image */}
        <div className="w-full h-80 bg-gray-50 relative overflow-hidden">
          <img 
            src={product.images[0]} 
            alt={product.name}
            className="w-full h-full object-contain object-center"
          />
          <div className="absolute top-4 right-4 bg-blue-500 text-white px-3 py-1 rounded-full text-xs font-medium">
            US to US Shipping
          </div>
        </div>

        {/* Product Info */}
        <div className="px-4 py-5">
          <div className="flex items-start justify-between mb-2">
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-gray-900 mb-1">{product.name}</h2>
              <p className="text-sm text-gray-500">{product.category}</p>
            </div>
          </div>

          {/* Rating */}
          <div className="flex items-center gap-2 mb-4">
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <i 
                  key={i} 
                  className={`${i < Math.floor(product.rating) ? 'ri-star-fill' : 'ri-star-line'} text-yellow-400 text-sm`}
                ></i>
              ))}
            </div>
            <span className="text-sm text-gray-600">{product.rating}</span>
            <span className="text-sm text-gray-400">({product.reviewCount} reviews)</span>
          </div>

          {/* Stock Status */}
          <div className="flex items-center gap-2 mb-6">
            <div className={`w-2 h-2 rounded-full ${product.inStock ? 'bg-green-500' : 'bg-red-500'}`}></div>
            <span className="text-sm text-gray-600">{product.inStock ? 'In Stock' : 'Out of Stock'}</span>
          </div>

          {/* Package Selection */}
          <div className="mb-6">
            <h3 className="text-base font-semibold text-gray-900 mb-3">Select Package</h3>
            <div className="grid grid-cols-2 gap-3">
              {packages.map((pkg, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedPackage(index)}
                  className={`p-4 rounded-xl border-2 transition-all ${
                    selectedPackage === index
                      ? 'border-teal-500 bg-teal-50'
                      : 'border-gray-200 bg-white'
                  }`}
                >
                  <div className="text-sm font-semibold text-gray-900">{pkg.pills} Pills</div>
                  <div className="text-lg font-bold text-teal-600 mt-1">${pkg.price}</div>
                  <div className="text-xs text-gray-500 mt-1">${(pkg.price / pkg.pills).toFixed(2)}/pill</div>
                </button>
              ))}
            </div>
          </div>

          {/* Quantity */}
          <div className="mb-6">
            <h3 className="text-base font-semibold text-gray-900 mb-3">Quantity</h3>
            <div className="flex items-center gap-4">
              <button
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center"
              >
                <i className="ri-subtract-line text-lg"></i>
              </button>
              <span className="text-xl font-semibold min-w-[40px] text-center">{quantity}</span>
              <button
                onClick={() => setQuantity(quantity + 1)}
                className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center"
              >
                <i className="ri-add-line text-lg"></i>
              </button>
            </div>
          </div>

          {/* Description */}
          <div className="mb-6">
            <h3 className="text-base font-semibold text-gray-900 mb-3">Description</h3>
            <p className="text-sm text-gray-600 leading-relaxed">{product.description}</p>
          </div>

          {/* Prescription Required */}
          {product.prescriptionRequired && (
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6">
              <div className="flex items-start gap-3">
                <i className="ri-alert-line text-amber-600 text-xl mt-0.5"></i>
                <div>
                  <h4 className="font-semibold text-amber-900 text-sm mb-1">Prescription Required</h4>
                  <p className="text-xs text-amber-700">This medication requires a valid prescription from a licensed healthcare provider.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm text-gray-600">Total Price</span>
          <span className="text-2xl font-bold text-teal-600">${packages[selectedPackage].price * quantity}</span>
        </div>
        <button
          onClick={handleAddToCart}
          disabled={!product.inStock}
          className="w-full bg-teal-500 text-white py-3.5 rounded-xl font-semibold disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          Add to Cart
        </button>
      </div>
    </div>
  );
}
